<div class="scheduler-view-container" #scheduler></div>
